import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  id: 'text1',
  name: 'text1',
  type: 'standard',
  moduleName: 'editor_module_text1',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius', 'padding'],
          link: columnDetail.link,
          border: columnDetail.border,
          background: columnDetail.background,
          color: columnDetail.text,
          upload: columnDetail.upload,
          radius: columnDetail.radius,
          padding: columnDetail.padding
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
